// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__Ar5wH","col":"CardReaderDesc_col__M3jky","label":"CardReaderDesc_label__2Zxfa"};